export default __webpack_public_path__ + "static/media/dfinity-explorer-logo-large.e727fdd1.png";